import type { IVoiceResponse, IVoiceUpdateData } from '@/types/voice-model';
import type { CommonResponse } from '@/utils/request';
import { Request } from '@/utils/request';

// voice list
export function voiceList() {
  return Request<IVoiceResponse>({
    url: '/rest/os/mind/voice/default',
    method: 'post'
  });
}

export function updateVoice(data: { data: IVoiceUpdateData }) {
  return Request<IVoiceResponse>({
    url: '/rest/os/mind/profile/voice/save',
    method: 'post',
    data
  });
}

export function cloneVoice(data: { file: File; text?: string }) {
  return Request<CommonResponse<{ demoAudio: string }>>({
    url: '/rest/os/main/speech/voice/clone',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function cloneVoiceTTS(data: { text: string }) {
  return Request<CommonResponse<{ voice: string }>>({
    url: '/rest/os/main/speech/voice/preview',
    method: 'post',
    data
  });
}

export function confirmCloneVoice() {
  return Request<CommonResponse<{ audioData: string }>>({
    url: '/rest/os/main/speech/custom/voice/confirm',
    method: 'post'
  });
}

export function speechToText(data: { audioBuffer: ArrayBuffer }) {
  return Request<
    CommonResponse<{
      parseResp: { content: string; duration: number; language: string };
      url: string;
    }>
  >({
    url: `/rest/os/qp/content/revise/file?contentType=audio/wav`,
    headers: {
      'Content-Type': 'application/octet-stream'
    },
    method: 'post',
    data: data.audioBuffer
  });
}

export interface IOpenAIStreamASR {
  streamPlatform: string;
  platformParam: {
    appKey: string;
  };
  wsUrl: string;
  token: string;
  expireTime: number;
  customParam: {
    model: string;
  };
}

export function getOpenAIStreamASR(language: string) {
  return Request<CommonResponse<IOpenAIStreamASR>>({
    url: `/rest/os/voice/streaming/gpt/planner`,
    method: 'get',
    params: {
      language
    }
  });
}
